import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Joyride from 'react-joyride';
import rightClickInfoConfig from '../config/rightClickInfoConfig';

const RightClickHandler = () => {
  const location = useLocation();
  const [showTour, setShowTour] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);

  useEffect(() => {
    const currentPath = location.pathname;
    const config = rightClickInfoConfig[currentPath];

    const handleShowTour = (e) => {
      if (config && config.tourSteps) {
        const doNotShowAgain = localStorage.getItem(config.doNotShowAgainKey);
        if (!doNotShowAgain || e.detail?.forceShow) { // Added forceShow for testing/re-showing
          setTourSteps(config.tourSteps);
          setShowTour(true);
        }
      }
    };

    // Clear tour if path changes
    setShowTour(false);
    setTourSteps([]);

    // Listen for a generic event to show tour for the current route
    window.addEventListener(`showTour-${currentPath.replace(/\//g, '_')}`, handleShowTour);

    return () => {
      window.removeEventListener(`showTour-${currentPath.replace(/\//g, '_')}`, handleShowTour);
    };
  }, [location.pathname]);

  const handleJoyrideCallback = (data) => {
    const { status, action, type, index } = data;
    const currentPath = location.pathname;
    const config = rightClickInfoConfig[currentPath];

    if (["finished", "skipped"].includes(status) && config?.doNotShowAgainKey) {
      localStorage.setItem(config.doNotShowAgainKey, 'true');
      setShowTour(false);
    } else if (status === 'ready' && action === 'start') {
      // Tour is ready to start, ensure it's visible
      setShowTour(true);
    }
  };

  return (
    <>
      {showTour && (
        <Joyride
          steps={tourSteps}
          continuous
          showSkipButton
          showProgress
          scrollToFirstStep
          scrollToStep
          disableOverlayClose
          disableScrolling={false}
          spotlightPadding={6}
          styles={{ options: { zIndex: 100001 } }}
          callback={handleJoyrideCallback}
        />
      )}
    </>
  );
};

export default RightClickHandler;
